module.exports = __webpack_public_path__ + "img/no-favourite.c919c7ee.svg";